import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'default',
  size = 'default',
  className = '',
  ...props
}) => {
  const base = "rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 ";

  // Only apply color classes if no bg-[] class is provided in className
  const hasCustomBg = className.includes('bg-[') || className.includes('bg-');
  let color = hasCustomBg ? '' : "bg-navy text-white hover:bg-orange";
  if (!hasCustomBg) {
    if (variant === "secondary") {
      color = "bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300";
    } else if (variant === "destructive") {
      color = "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500";
    } else if (variant === "outline") {
      color = "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50";
    } else {
      color = "bg-navy text-white hover:bg-orange focus:ring-teal";
    }
  }

  let sizeClasses = "px-3 py-1.5";
  if (size === "sm") {
    sizeClasses = "px-2 py-1 text-sm";
  } else if (size === "lg") {
    sizeClasses = "px-4 py-2 text-lg";
  } else if (size === "icon") {
    sizeClasses = "p-2";
  }

  return (
    <button
      className={`${base} ${color} ${sizeClasses} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
